import { AllianzJobStatus } from '@40seas/entities/allianz';
import { EnumColor } from '@40seas/frontend/common/providers';

export const allianzJobStatusColorMapping = {
    [AllianzJobStatus.Pending]: 'default',
    [AllianzJobStatus.Processed]: 'success',
    [AllianzJobStatus.TechnicalError]: 'error',
    [AllianzJobStatus.FunctionalError]: 'error',
} as { [key in AllianzJobStatus]: EnumColor };
